(function ($) {

	stickyHeaderCheck();

    $(window).scroll(function () {
		stickyHeaderCheck();
    });


    function stickyHeaderCheck() {

    	$('header').toggleClass('is-sticky', $(document).scrollTop() > 120);

    }

})(jQuery);